import React from 'react';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import ProblemSection from '../components/home/ProblemSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import AudienceSection from '../components/home/AudienceSection';
import FinalCTASection from '../components/home/FinalCTASection';
import '../styles/naabu.css';

const LandingPage = () => {
  return (
    <div style={{ background: '#000', minHeight: '100vh' }}>
      <Navigation />
      <main>
        <HeroSection />
        <ProblemSection />
        <HowItWorksSection />
        <AudienceSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
